import { ChartData } from '../types';

export const createChartOptions = (chartData: ChartData) => ({
  chart: {
    type: 'bar' as const,
    height: 350,
    toolbar: {
      show: true
    }
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%',
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent']
  },
  xaxis: {
    categories: chartData.categories,
    labels: {
      rotate: -45
    }
  },
  yaxis: {
    title: {
      text: 'Count'
    }
  },
  fill: {
    opacity: 1
  },
  tooltip: {
    y: {
      formatter: function (val: number) {
        return val.toString()
      }
    }
  },
  legend: {
    position: 'top' as const
  }
});
